import Vue from 'vue';
import {
    GET_NOTELIST_REQUEST,
    GET_NOTELIST_SUCCESS,
    GET_NOTELIST_FAILURE
} from '../mutationTypes';

const state = {
    loading: false,
    noteList: [],
    pageCount: 0,
    count: 0
};
const mutations = {
    [GET_NOTELIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_NOTELIST_SUCCESS](state, res) {
        state.loading = false;
        state.noteList = res.list;
        state.pageCount = res.page_count;
        state.count = res.count;
    },
    [GET_NOTELIST_FAILURE](state) {
        state.loading = false;
        state.noteList = [];
        state.pageCount = 0;
        state.count = 0;
    },
};

export const actions = {
    async getNoteList({ commit }, params) {
        commit(GET_NOTELIST_REQUEST);
        const res = await Vue.$ajax.get('noticeList', params);

        if (!res.errorType) {
            commit(GET_NOTELIST_SUCCESS, res);
        } else {
            commit(GET_NOTELIST_FAILURE);
        }
    }
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/notice.js